import { normalizeGeneratedText } from "@/lib/normalize-generated-text";

/**
 * Human-readable label for a quiz option.
 * Keep this utility client-safe; do not import server-only logging/context here.
 */
export function coerceQuizOptionLabel(opt: unknown): string {
  if (typeof opt === "string") {
    return normalizeGeneratedText(opt);
  }
  if (typeof opt === "object" && opt !== null) {
    const r = opt as Record<string, unknown>;
    const text = r.text ?? r.label ?? r.value;
    if (typeof text === "string") {
      return normalizeGeneratedText(text);
    }
    try {
      return normalizeGeneratedText(JSON.stringify(opt));
    } catch {
      return "";
    }
  }
  return normalizeGeneratedText(String(opt));
}
